module.exports = __webpack_public_path__ + "media/images/signal-strength-20-2e2a8c582207d0aefde390d8452e1efe.svg";